import React from 'react';
import DownloadView from './DownloadView';

export default ({keys,caption})=>(!keys || !keys.length ? null :<div className='downloads--product'>
    <h3>{caption}</h3>
    {keys.map(key=><DownloadView data={key} key={key.key}/>)}
</div>);